import { render, staticRenderFns } from "./scene3Mobile.vue?vue&type=template&id=14a82bcc&scoped=true&"
import script from "./scene3Mobile.vue?vue&type=script&lang=js&"
export * from "./scene3Mobile.vue?vue&type=script&lang=js&"
import style0 from "./scene3Mobile.vue?vue&type=style&index=0&id=14a82bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a82bcc",
  null
  
)

export default component.exports